import api from "./api";

export const reportService = {
  getLeadReport: (filters = {}) =>
    api.get("/reports/leads", { params: filters }).then((res) => res.data),
  getRevenueReport: (filters = {}) =>
    api.get("/reports/revenue", { params: filters }).then((res) => res.data),
  getTeamPerformance: (filters = {}) =>
    api.get("/reports/team-performance", { params: filters }).then((res) => res.data),
};
